module.exports = __webpack_public_path__ + "static/show_blank_line_between_items-0a856c83d4a9d43d2d0ff09de39b9710.png";